{
  "version": 1,
  "asset_id": "5e5b42b0-d03e-462d-b0ac-73fa6dff925a",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/5e5b42b0-d03e-462d-b0ac-73fa6dff925a/bypass-revision-oversized-pouch-en-1200.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/5e5b42b0-d03e-462d-b0ac-73fa6dff925a/bypass-revision-oversized-pouch-en-1200.webp",
  "original_filename": "bypass-revision-oversized-pouch-en-1200.webp",
  "size": 73566,
  "content_type": "image/webp",
  "created_at": "2026-10-05T22:11:33Z"
}
